import React from 'react';

export default function JournalApproval() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Journal Approval</h1>
      <p className="text-gray-500">Halaman Journal Approval</p>
    </div>
  );
}
